import axios from 'axios';
import { initData } from '../lib/tg';

const baseURL = import.meta.env.VITE_API_BASE_URL || '';

export const api = axios.create({
  baseURL,
  timeout: 15000,
});

api.interceptors.request.use((config) => {
  config.headers = config.headers ?? {};
  (config.headers as any)['X-Telegram-Init-Data'] = initData();
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    // Pass through; pages handle their own errors.
    return Promise.reject(err);
  },
);

export async function mintSseTicket(): Promise<string> {
  // EventSource can't set custom headers; instead of leaking initData via the
  // query string (which would land in access logs), exchange it server-side
  // for a short-lived one-shot ticket and put that in the URL.
  const r = await api.post<{ ticket: string }>('/api/sse/ticket');
  return r.data.ticket;
}

export function sseUrlWithTicket(path: string, ticket: string): string {
  const sep = path.includes('?') ? '&' : '?';
  return `${baseURL}${path}${sep}ticket=${encodeURIComponent(ticket)}`;
}
